import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const VisualizerDriftAccelerationListItem = (props) => {
    const { acceleration, updateVisualizerSettings } = props;

    const onAccelerationChange = (value) => updateVisualizerSettings({ drift: { acceleration: value } });

    return (
        <SliderListItem
            title='Reactivity'
            displayMultiplier={1}
            value={acceleration}
            min={0}
            max={100}
            step={1}
            onValueChange={onAccelerationChange}
            toolTip='How much drift speeds up during loud audio.'
        />
    );
};

const mapStateToProps = (state) => {
    const { acceleration } = state.createPreview.present.videoSettings.visualizer.drift;
    return { acceleration };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftAccelerationListItem);
